import React from "react";
import { Mail, Phone } from "lucide-react";
import "../styles/Navbar.css";

export default function Navbar({ onContactClick }) {
  return (
    <header className="hero-unique-navbar">
      {/* Logo */}
      <div className="hero-unique-navbar-logo">
        <img
          src="/logo-without-background.png"
          height="60"
          className="d-inline-block align-top me-2"
          alt="Solar Simulator Logo"
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/60x60/3D5A73/FFFFFF?text=☀️';
          }}
        />
      </div>

      {/* Menu */}
      <nav className="hero-unique-navbar-menu flex justify-center items-center w-full">
        <span className="hero-unique-navbar-title fs-4">Solar Simulator</span>
      </nav>

      {/* Actions */}
      <div className="hero-unique-navbar-actions">
        <button className="hero-unique-navbar-btn"
         onClick={onContactClick}
        >
            Contact
        </button>
        <Mail size={22} className="hero-unique-navbar-icon" />
        <Phone size={22} className="hero-unique-navbar-icon" />
      </div>
    </header>
  );
}
